import { Component } from '@angular/core';
import { AgRendererComponent } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { LogService } from '../../services/log.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'tank-grid-alarm-renderer',
  templateUrl: "./tank-grid-alarm-renderer.component.html",
})


export class TankGridAlarmRendererComponent implements AgRendererComponent {
  public alarmList: any[];
  public alarmInfo: any;

  constructor(
    public translate: TranslateService,
    private logger: LogService,
  ) { }


  // gets called once before the renderer is used
  agInit(params: ICellRendererParams): void {
    this.parseData(params);
  }

  parseData(params: ICellRendererParams): void {
    this.setAlarmInfo(params);
  }

  setAlarmInfo(params: any) {
    const fieldName = params.colDef.field;
    this.alarmList = params.data[fieldName];

    // if there is nothing in the alarm list array, bail
    if (!this.alarmList?.length) {
      this.alarmInfo = null;
      return;
    }

    // When this column is filtered, show the first alarm the filter matched so the cell agrees with the filter.
    // Only an active filter can match, so checking that first avoids building the grid's whole filter model
    // for every cell on every render.
    if (params.column.isFilterActive()) {
      const values: string[] = params.api.getFilterModel()?.[fieldName]?.values ?? [];
      const match = this.alarmList.find(alarm => values.includes(alarm.status) || values.includes(alarm.abbr));
      if (match) {
        this.alarmInfo = match;
        return;
      }
    }
    this.alarmInfo = this.alarmList[0];
  }

  // gets called whenever the user gets the cell to refresh
  refresh(params: ICellRendererParams) {
    // set value into cell again
    this.parseData(params);
    return true;
  }

  getValueToDisplay(params: ICellRendererParams) {
    return params.valueFormatted ? params.valueFormatted : params.value;
  }
}
